import swaggerClient from "../remote-client";

export default class FondoEstPerTeService {
  callDownloadGuidePDFFile(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.getDocumentGuideWithDocType(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }
}
